export default function USBC(props: any) {
    return (
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="4.28516" y="17.167" width="39.4286" height="15.4286" rx="7.71429" stroke="white" strokeWidth="2.25" />
            <path d="M12 24.8809H36" stroke="white" strokeWidth="2.25" strokeLinecap="round" />
        </svg>
    );
}
